import { ReactComponent as email } from '../../assets/v2/icons/email.svg';
import { ReactComponent as remove } from '../../assets/v2/icons/delete.svg';
import { ReactComponent as removeFilled } from '../../assets/v2/icons/delete_filled.svg';
import { ReactComponent as favorite } from '../../assets/v2/icons/favorite.svg';
import { ReactComponent as favorites } from '../../assets/v2/icons/favorites.svg';
import { ReactComponent as chevronDown } from '../../assets/v2/icons/chevron_down.svg';
import { ReactComponent as chevronUp } from '../../assets/v2/icons/chevron_up.svg';
import { ReactComponent as unCheckbox } from '../../assets/v2/icons/unCheckbox.svg';
import { ReactComponent as checkbox } from '../../assets/v2/icons/checkbox.svg';
import { ReactComponent as search } from '../../assets/v2/icons/search.svg';
import { ReactComponent as refresh } from '../../assets/v2/icons/refresh.svg';
import { ReactComponent as chevronLeft } from '../../assets/v2/icons/chevron_left.svg';
import { ReactComponent as chevronsLeft } from '../../assets/v2/icons/chevrons_left.svg';
import { ReactComponent as chevronRight } from '../../assets/v2/icons/chevron_right.svg';
import { ReactComponent as chevronsRight } from '../../assets/v2/icons/chevrons_right.svg';
import { ReactComponent as checkboxDefault } from '../../assets/v2/icons/checkbox_default.svg';
import { ReactComponent as money } from '../../assets/v2/icons/money.svg';
import { ReactComponent as megaphone } from '../../assets/v2/icons/megaphone.svg';
import { ReactComponent as phoneCall } from '../../assets/v2/icons/phone_call.svg';
import { ReactComponent as viewed } from '../../assets/v2/icons/viewed.svg';
import { ReactComponent as hide } from '../../assets/v2/icons/hide.svg';
import { ReactComponent as whatsapp } from '../../assets/v2/icons/whatsapp.svg';
import { ReactComponent as calendar } from '../../assets/v2/icons/calendar.svg';
import { ReactComponent as close } from '../../assets/v2/icons/close.svg';
import { ReactComponent as closeCustom } from '../../assets/v2/icons/closeCustom.svg';
import { ReactComponent as unReadEmail } from '../../assets/v2/icons/unReadEmail.svg';
import { ReactComponent as readEmail } from '../../assets/v2/icons/readEmail.svg';
import { ReactComponent as favoriteFilled } from '../../assets/v2/icons/favorite_filled.svg';
import { ReactComponent as send } from '../../assets/v2/icons/send.svg';
import { ReactComponent as reply } from '../../assets/v2/icons/reply.svg';
import { ReactComponent as valid } from '../../assets/v2/icons/valid.svg';
import { ReactComponent as arrowLeft } from '../../assets/v2/icons/arrow_left.svg';
import { ReactComponent as question } from '../../assets/v2/icons/question.svg';
import { ReactComponent as favoriteRed } from '../../assets/v2/icons/favorite-red.svg';
import { ReactComponent as savedSearches } from '../../assets/v2/icons/savedSearches.svg';
import { ReactComponent as savedSearchesSilenced } from '../../assets/v2/icons/savedSearches_silenced.svg';
import { ReactComponent as edit } from '../../assets/v2/icons/edit.svg';
import { ReactComponent as messages } from '../../assets/v2/icons/messages.svg';
import { ReactComponent as alertRed } from '../../assets/icons/AlertCircle.svg';
import { ReactComponent as alertBlue } from '../../assets/icons/AlertCircleBlue.svg';
import { ReactComponent as contracts } from '../../assets/v2/icons/currency.svg';
import { ReactComponent as realEstate } from '../../assets/v2/icons/realestate.svg';
import { ReactComponent as user } from '../../assets/v2/icons/user.svg';
import { ReactComponent as interested } from '../../assets/v2/icons/inbox.svg';
import { ReactComponent as misAvisos } from '../../assets/v2/icons/avisos.svg';
import { ReactComponent as activity } from '../../assets/v2/icons/activity.svg';
import { ReactComponent as stats } from '../../assets/v2/icons/stats.svg';
import { ReactComponent as upload } from '../../assets/v2/icons/upload.svg';
import { ReactComponent as timer } from '../../assets/v2/icons/timer.svg';
import { ReactComponent as agent } from '../../assets/v2/icons/agent.svg';
import { ReactComponent as copy } from '../../assets/icons/copy.svg';
import { ReactComponent as check } from '../../assets/v2/icons/check.svg';
import { ReactComponent as alert } from '../../assets/v2/icons/alert.svg';
import { ReactComponent as requestVisit } from '../../assets/v2/icons/request_visit.svg';
import { ReactComponent as lock } from '../../assets/v2/icons/lock.svg';

export default {
  email,
  remove,
  removeFilled,
  favorite,
  favorites,
  favoriteFilled,
  favoriteRed,
  chevronDown,
  chevronUp,
  unCheckbox,
  checkbox,
  search,
  refresh,
  chevronLeft,
  chevronsLeft,
  chevronRight,
  chevronsRight,
  checkboxDefault,
  money,
  megaphone,
  phoneCall,
  viewed,
  hide,
  whatsapp,
  calendar,
  close,
  closeCustom,
  unReadEmail,
  readEmail,
  send,
  reply,
  valid,
  arrowLeft,
  question,
  savedSearches,
  savedSearchesSilenced,
  edit,
  messages,
  alertRed,
  alertBlue,
  contracts,
  realEstate,
  user,
  interested,
  misAvisos,
  activity,
  stats,
  upload,
  timer,
  agent,
  copy,
  check,
  alert,
  requestVisit,
  lock
};
